module.exports = __webpack_public_path__ + "img/banner2.8468ec0c.jpg";